// extracted by mini-css-extract-plugin
export default {"propertyDetails":"ListIconsDetails_propertyDetails__sNNLl"};